module.exports = __webpack_public_path__ + "images/chevron-f574872a.svg";